// Pure scoring functions. Imported by both the Worker (analytics) and the
// React frontend (live result display). Keep dependency-free.

export const MAX_YEAR_SCORE = 5000
export const MAX_ROUND_SCORE = MAX_YEAR_SCORE
export const ROUNDS_PER_DAY = 5
export const MAX_DAILY_SCORE = ROUNDS_PER_DAY * MAX_ROUND_SCORE

export type RoundAnswer = {
  year: number
  year_min: number
  year_max: number
}

export type RoundGuess = {
  year: number
}

export type RoundResult = {
  year_score: number
  total: number
  year_delta: number       // years outside the bracket (0 if inside)
}

/**
 * Year score: full 5000 if the guess is inside [year_min, year_max].
 * Outside the bracket, exponential decay with 10-year half-life-ish.
 */
export function scoreYear(guessYear: number, answer: RoundAnswer): { score: number; delta: number } {
  let delta = 0
  if (guessYear < answer.year_min) delta = answer.year_min - guessYear
  else if (guessYear > answer.year_max) delta = guessYear - answer.year_max
  if (delta === 0) return { score: MAX_YEAR_SCORE, delta: 0 }
  const score = Math.round(MAX_YEAR_SCORE * Math.exp(-delta / 10))
  return { score, delta }
}

export function scoreRound(guess: RoundGuess, answer: RoundAnswer): RoundResult {
  const y = scoreYear(guess.year, answer)
  return {
    year_score: y.score,
    total: y.score,
    year_delta: y.delta,
  }
}
